const PokemonBadges = {
    "pokemon-badge-boulder":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-boulder",
        "nicename": "Pokémon - Badge - Boulder"
    },
    "pokemon-badge-cascade":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-cascade",
        "nicename": "Pokémon - Badge - Cascade"
    },
    "pokemon-badge-thunder":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-thunder",
        "nicename": "Pokémon - Badge - Thunder"
    },
    "pokemon-badge-rainbow":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-rainbow",
        "nicename": "Pokémon - Badge - Rainbow"
    },
    "pokemon-badge-soul":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-cascade",
        "nicename": "Pokémon - Badge - Soul"
    },
    "pokemon-badge-marsh":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-marsh",
        "nicename": "Pokémon - Badge - Marsh"
    },
    "pokemon-badge-volcano":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-volcano",
        "nicename": "Pokémon - Badge - Volcano"
    },
    "pokemon-badge-earth":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-earth",
        "nicename": "Pokémon - Badge - Earth"
    },
    "pokemon-badge-zephyr":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-zephyr",
        "nicename": "Pokémon - Badge - Zephyr"
    },
    "pokemon-badge-hive":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-hive",
        "nicename": "Pokémon - Badge - Hive"
    },
    "pokemon-badge-plain":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-plain",
        "nicename": "Pokémon - Badge - Plain"
    },
    "pokemon-badge-fog":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-fog",
        "nicename": "Pokémon - Badge - Fog"
    },
    "pokemon-badge-storm":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-storm",
        "nicename": "Pokémon - Badge - Storm"
    },
    "pokemon-badge-mineral":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-mineral",
        "nicename": "Pokémon - Badge - Mineral"
    },
    "pokemon-badge-glacier":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-glacier",
        "nicename": "Pokémon - Badge - Glacier"
    },
    "pokemon-badge-rising":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-rising",
        "nicename": "Pokémon - Badge - Rising"
    },
    "pokemon-badge-stone":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-stone",
        "nicename": "Pokémon - Badge - Stone"
    },
    "pokemon-badge-knuckle":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-knuckle",
        "nicename": "Pokémon - Badge - Knuckle"
    },
    "pokemon-badge-dynamo":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-dynamo",
        "nicename": "Pokémon - Badge - Dynamo"
    },
    "pokemon-badge-heat":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-heat",
        "nicename": "Pokémon - Badge - Heat"
    },
    "pokemon-badge-balance":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-balance",
        "nicename": "Pokémon - Badge - Balance"
    },
    "pokemon-badge-feather":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-feather",
        "nicename": "Pokémon - Badge - Feather"
    },
    "pokemon-badge-mind":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-mind",
        "nicename": "Pokémon - Badge - Mind"
    },
    "pokemon-badge-rain":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-rain",
        "nicename": "Pokémon - Badge - Rain"
    },
    "pokemon-badge-coal":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-coal",
        "nicename": "Pokémon - Badge - Coal"
    },
    "pokemon-badge-forest":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-forest",
        "nicename": "Pokémon - Badge - Forest"
    },
    "pokemon-badge-cobble":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-cobble",
        "nicename": "Pokémon - Badge - Cobble"
    },
    "pokemon-badge-fen":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-fen",
        "nicename": "Pokémon - Badge - Fen"
    },
    "pokemon-badge-relic":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-relic",
        "nicename": "Pokémon - Badge - Relic"
    },
    "pokemon-badge-mine":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-mine",
        "nicename": "Pokémon - Badge - Mine"
    },
    "pokemon-badge-icicle":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-icicle",
        "nicename": "Pokémon - Badge - Icile"
    },
    "pokemon-badge-beacon":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-beacon",
        "nicename": "Pokémon - Badge - Beacon"
    },
    "pokemon-badge-trio":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-trio",
        "nicename": "Pokémon - Badge - Trio"
    },
    "pokemon-badge-basic":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-basic",
        "nicename": "Pokémon - Badge - Basic"
    },
    "pokemon-badge-toxic":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-toxic",
        "nicename": "Pokémon - Badge - Toxic"
    },
    "pokemon-badge-insect":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-insect",
        "nicename": "Pokémon - Badge - Insect"
    },
    "pokemon-badge-bolt":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-bolt",
        "nicename": "Pokémon - Badge - Bolt"
    },
    "pokemon-badge-quake":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-quake",
        "nicename": "Pokémon - Badge - Quake"
    },
    "pokemon-badge-jet":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-jet",
        "nicename": "Pokémon - Badge - Jet"
    },
    "pokemon-badge-freeze":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-freeze",
        "nicename": "Pokémon - Badge - Freeze"
    },
    "pokemon-badge-legend":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-legend",
        "nicename": "Pokémon - Badge - Legend"
    },
    "pokemon-badge-wave":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-wave",
        "nicename": "Pokémon - Badge - Wave"
    },
    "pokemon-badge-bug":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-bug",
        "nicename": "Pokémon - Badge - Bug"
    },
    "pokemon-badge-cliff":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-cliff",
        "nicename": "Pokémon - Badge - Cliff"
    },
    "pokemon-badge-rumble":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-rumble",
        "nicename": "Pokémon - Badge - Rumble"
    },
    "pokemon-badge-plant":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-plant",
        "nicename": "Pokémon - Badge - Plant"
    },
    "pokemon-badge-voltage":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-voltage",
        "nicename": "Pokémon - Badge - Voltage"
    },
    "pokemon-badge-fairy":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-fairy",
        "nicename": "Pokémon - Badge - Fairy"
    },
    "pokemon-badge-psychic":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-psychic",
        "nicename": "Pokémon - Badge - Psychic"
    },
    "pokemon-badge-iceberg":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-iceberg",
        "nicename": "Pokémon - Badge - Iceberg"
    },
    "pokemon-badge-grass":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-grass",
        "nicename": "Pokémon - Badge - Grass"
    },
    "pokemon-badge-water":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-water",
        "nicename": "Pokémon - Badge - Water"
    },
    "pokemon-badge-fire":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-fire",
        "nicename": "Pokémon - Badge - Fire"
    },
    "pokemon-badge-fighting":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-fighting",
        "nicename": "Pokémon - Badge - Fighting"
    },
    "pokemon-badge-ghost":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-fighting",
        "nicename": "Pokémon - Badge - Fighting"
    },
    "pokemon-badge-fairy-galar":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-fairy-galar",
        "nicename": "Pokémon - Badge - Fairy"
    },
    "pokemon-badge-rock":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-rock",
        "nicename": "Pokémon - Badge - Rock"
    },
    "pokemon-badge-ice":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-rock",
        "nicename": "Pokémon - Badge - Rock"
    },
    "pokemon-badge-dark":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-dark",
        "nicename": "Pokémon - Badge - Dark"
    },
    "pokemon-badge-dragon":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-dragon",
        "nicename": "Pokémon - Badge - Dragon"
    },
    "pokemon-badge-tranquility":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-tranquility",
        "nicename": "Pokémon - Badge - Tranquility"
    },
    "pokemon-badge-freedom":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-freedom",
        "nicename": "Pokémon - Badge - Freedom"
    },
    "pokemon-badge-patience":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-patience",
        "nicename": "Pokémon - Badge - Patience"
    },
    "pokemon-badge-glacier-masters":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-glacier-masters",
        "nicename": "Pokémon - Badge - Glacier"
    },
    "pokemon-badge-pride":{
        "type":"webp",
        "content":"pokemon-badges/pokemon-badge-pride",
        "nicename": "Pokémon - Badge - Pride"
    },
}

export default PokemonBadges;